import { render, staticRenderFns } from "./CadastroTerritorioVegaSemCar.vue?vue&type=template&id=01039c8f&scoped=true&lang=pug"
import script from "./CadastroTerritorioVegaSemCar.vue?vue&type=script&lang=js"
export * from "./CadastroTerritorioVegaSemCar.vue?vue&type=script&lang=js"
import style0 from "./CadastroTerritorioVegaSemCar.vue?vue&type=style&index=0&id=01039c8f&prod&lang=scss&scoped=true"
import style1 from "./CadastroTerritorioVegaSemCar.vue?vue&type=style&index=1&id=01039c8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01039c8f",
  null
  
)

export default component.exports